import "./AddOrRemoveFilter.css";

import {
  ButtonIcon,
  Icon,
  Menu,
  type MenuOption,
} from "@saviynt/design-system";
import { useIntl } from "react-intl";
import { AddFilterOption } from "../../pages/PoliciesForm/InventorySidePanel/SummaryTab/components/Ownership/components/AssignOwnerFilter/AssignOwnerFilterOptions";
import { DEFAULT_ADD_OR_REMOVE_FILTER_CATEGORIES } from "../../constants/policies.constants";

interface AddOrRemoveFilterProps {
  addFilterOptions: AddFilterOption[] | MenuOption[];
  onAddFilterChange: (option: AddFilterOption) => void;
  dataTestId: string;
}

function AddOrRemoveFilter({
  addFilterOptions,
  onAddFilterChange,
  dataTestId,
}: AddOrRemoveFilterProps) {
  const intl = useIntl();

  return (
    <Menu
      kind="addAndRemove"
      label={intl.formatMessage({
        id: "eJ/Ptk",
        defaultMessage: "Add or Remove Filters",
        description: "Message: Add or Remove Filters",
      })}
      options={addFilterOptions}
      onChange={onAddFilterChange}
      defaultExpandedCategories={DEFAULT_ADD_OR_REMOVE_FILTER_CATEGORIES}
      trigger={
        <ButtonIcon
          kind="outlinedNeutral"
          ariaLabel={intl.formatMessage({
            id: "eJ/Ptk",
            defaultMessage: "Add or Remove Filters",
            description: "Message: Add or Remove Filters",
          })}
          size="medium"
          icon={<Icon kind="Add" size="xSmall" />}
        />
      }
      shouldCloseMenuOnItemClick={false}
      className="policies-AddOrRemoveFilter"
      dataTestId={dataTestId}
      isPortalEnabled
    />
  );
}

export default AddOrRemoveFilter;
